import { Decimal } from 'decimal.js'
import { store } from '@redux/store'
import { CURRENCY, PLATFORM } from '@const'
import { getPfID } from './platform'

export function currencyFormatter(money, decimal, rate) {
    /** 全域設定 */
    const globalDecimal = store.getState().auth && store.getState().auth.isCompleteDecimal ? 6 : 2
    if (!money) {
        money = 0
    } else if (money === CURRENCY.EMPTY_MONEY) {
        return CURRENCY.EMPTY_MONEY
    }
    decimal = decimal !== undefined ? decimal : globalDecimal
    if (rate) {
        money = new Decimal(money).mul(rate)
    }
    // remove all float after decimal
    // 小數位不加千分位
    const splitMoney = new Decimal(parseInt(new Decimal(money).mul(Math.pow(10, decimal)))).div(Math.pow(10, decimal)).toFixed(decimal).toString().split('.')
    return decimal ? `${splitMoney[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}.${splitMoney[1]}` : splitMoney[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function getPfCurrency(pfID) {
    const pf = [...PLATFORM.PF_INFO, ...PLATFORM.DEV_PF_INFO].find((pf) => pf.pfID === pfID)
    return pf ? pf.currency : CURRENCY.DEFAULT_CURRENCY
}

export function getPfSubPfCurrency(pfSubPfID) {
    return getPfCurrency(getPfID(pfSubPfID))
}

export function getCurrencyRate(currency) {
    const exchangeCurrencyMap = store.getState().dataService ? store.getState().dataService.exchangeCurrencyMap : null

    return exchangeCurrencyMap && exchangeCurrencyMap[currency] ? 1 / exchangeCurrencyMap[currency].rate : 1
}

export function currencyTrans(money, currency) {
    const decimal = store.getState().auth.isCompleteDecimal ? 6 : 2
    const display = currencyFormatter(money, decimal, getCurrencyRate(currency))
    return display
}
